import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { fetchUserProductMemberships } from 'store/actions/users/product-memberships/fetchUserProductMemberships';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import UserProductMembershipsList from './UserProductMembershipsList';
import { filter, isEmpty } from 'lodash';

class UserProductMemberhipsListContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            initialRender: true,
        };
    }

    componentDidMount() {
        this.refetchProductMemberships();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.initialRender !== this.state.initialRender && isEmpty(this.props.memberships) && prevProps.isLoading !== this.props.isLoading) {
            this.refetchProductMemberships();
            this.setState({
                initialRender: false,
            });
        }
    }

    refetchProductMemberships = () => {
        const {
            userId,
            refetchProductMembershipsDispatch,
            filter,
            total,
            size,
            offset,
        } = this.props;

        refetchProductMembershipsDispatch({
            params: {
                user_id: userId,
            },
            filter,
            total,
            size,
            offset,
        });
    }

    render() {
        const {
            isLoading,
            memberships,
        } = this.props;

        return (
            <UserProductMembershipsList
                isLoading={ isLoading }
                memberships={ memberships }
                refetchProductMemberships={ this.refetchProductMemberships }
                resource='product-memberships'
            />
        );
    }
}

UserProductMemberhipsListContainer.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    memberships: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        user_id: PropTypes.number,
        product_membership_id: PropTypes.number,
        user_product_membership_pool_id: PropTypes.number,
        product_membership: PropTypes.object,
        is_scheduled: PropTypes.bool,
        group_id: PropTypes.number,
    })),
    refetchProductMembershipsDispatch: PropTypes.func.isRequired,
    userId: PropTypes.number.isRequired,
    filter: PropTypes.object,
    total: PropTypes.number,
    size: PropTypes.number,
    offset: PropTypes.number,
};

const mapStateToProps = (state, props) => {
    const { data, loading, ...restState } = state.userProductMemberships;

    return {
        isLoading: loading,
        memberships: filter(data, { user_id: props.userId }),
        ...restState,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        refetchProductMembershipsDispatch: (payload) => {
            return dispatch(fetchUserProductMemberships(payload));
        },
    };
};

const enhance = compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )
);

export default enhance(UserProductMemberhipsListContainer);



// WEBPACK FOOTER //
// ./src/pages/users/product-memberships/UserProductMemberhipsListContainer.js